import request from '@/utils/request'
// 查询指定资源类型订购记录
export function findResPurchaseRecords(params) {
  return request({
    url: `/agent_resource_bundle_purchase_records`,
    method: 'get',
    params: params
  })
}
